import { SortOrder } from '@models/table.model.ts';
import { SortTuple } from '@store/media-library-store/media-library.model';

export const querySlice = (set: any, get: any) => ({
  updatePagination: (newPage: number, newRowsPerPage: number) =>
    set({
      pagination: {
        ...get().pagination,
        page: newPage,
        rowsPerPage: newRowsPerPage
      }
    }),

  updateSort: (columnId: string, order: SortOrder) =>
    set({
      sort: [columnId, order] as SortTuple,
      pagination: { ...get().pagination, page: 1 }
    }),

  updateFilters: (columnId: string, selectedFilters: string[]) =>
    set({
      filter: { ...get().filter, [columnId]: selectedFilters },
      pagination: { ...get().pagination, page: 1 }
    }),

  updateSearch: (columnId: string, value: string) => {
    const { search } = get();

    if (search[columnId] === value) return;

    set({
      search: { ...search, [columnId]: value },
      pagination: { ...get().pagination, page: 1 }
    });
  },

  resetSearch: () => set({ search: {} }),

  resetQuery: () =>
    set({
      pagination: { page: 1, rowsPerPage: 12, totalPages: 0 },
      sort: ['', SortOrder.Ascending] as SortTuple,
      filter: {},
      search: {}
    })
});
